export const EMAIL_NAVIGATE = 'EMAIL_NAVIGATE';
export const LIST_NAVIGATE = 'LIST_NAVIGATE';
export const RECIPIENT_NAVIGATE = 'RECIPIENT_NAVIGATE';
export const SEQUENCE_GET = 'SEQUENCE_GET';
export const QUEUED_EMAILS_GET = 'QUEUED_EMAILS_GET';
export const QUEUED_EMAILS_REFRESH = 'QUEUED_EMAILS_REFRESH';
export const QUEUED_EMAILS_SORT = 'QUEUED_EMAILS_SORT';
export const UPDATE_EMAIL_SEND_DATE = 'UPDATE_EMAIL_SEND_DATE';
